module.exports = __webpack_public_path__ + "static/media/28DGC3.0deea47a.jpg";